import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoWifi = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>Wifi</title>
    <path
      d="M7.854 15.428c2.562-2.134 5.808-3.429 9.142-3.429 3.335 0 6.58 1.295 9.143 3.429M3.282 11.428c3.429-3.429 8.665-5.715 13.715-5.715 5.05 0 10.285 2.286 13.714 5.715M12.426 20c1.143-1.143 2.957-1.714 4.57-1.714 1.615 0 3.429.571 4.572 1.714"
      stroke="currentColor"
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <circle cx={16.997} cy={25.142} r={2.285} fill="currentColor" />
  </svg>
);
export default SvgIcoWifi;
